import { ReactKeycloakProvider } from "@react-keycloak/web";
import React from "react";
import keycloak from "config/keycloak";
// import {useDispatch} from "react-redux";
import {Spinner} from "reactstrap";
// @ts-ignore
import store from 'store'


const isExternal = () => {
  return /^\/external(?=\/|$)/i.test(window.location.hash.replace("#",""))
}


export const AuthProvider = ({children}: any) => {
  // const [token, setToken] = React.useState(keycloak.tokenParsed);
  // const dispatch = useDispatch()
  return (
    <ReactKeycloakProvider
      authClient={keycloak}
      initOptions={{
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
        // onLoad: 'login-required',
        responseMode: 'query'
      }}
      onTokens={(tokens: any) => {
        if(tokens.token){
          store.set('accessToken', tokens.token)
        }
        /* axios.get("http://127.0.0.1:8016/me?lol=2",{
          headers: {
            Authorization: `Bearer ${tokens.token}`
          }
        }) */
      }}
      onEvent={(event: any) => {
        console.log('event', event);
        if(event === 'onReady'){
          /* dispatch({
            type: 'user/LOAD_CURRENT_ACCOUNT',
          })
          console.log(keycloak?.createLogoutUrl()) */
        }
        if(event === "onReady" && !keycloak.authenticated) {
          if(!isExternal()){
            document.location.href = keycloak.createLoginUrl();
          }
        }
        if(event === 'onAuthSuccess'){
          // console.log('keycloak.tokenParsed',keycloak.tokenParsed)
          // setToken(keycloak.tokenParsed);
        }
      }}
      LoadingComponent={<div className={"text-center"}><Spinner color={"primary"} /></div>}
    >
      {children}
    </ReactKeycloakProvider>
  )
}
//
